module.exports = __webpack_public_path__ + "img/key-purple.e1f2fc27.png";